import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ADSB_API } from 'configs/endpoints';
import { NotifyADSBInDangerParams, PlaneObservation, PositionsByDateTimeRangeParams } from './dto';

export const adsbApi = createApi({
  reducerPath: 'adsbApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${ADSB_API}/ads-b`,
  }),
  endpoints: (builder) => ({
    findPositionsByDateTimeRange:
      builder.mutation<PlaneObservation[], PositionsByDateTimeRangeParams>({
        query: ({ dateTimes, org, dst }) => {
          let url = '/positionsByDateTimeRange';

          const queryParams = [];
          if (org) queryParams.push(`org=${org}`);
          if (dst) queryParams.push(`dst=${dst}`);

          if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
          }

          return {
            url,
            method: 'POST',
            body: { dateTimes },
          };
        },
      }),
    notifyADSBInDanger:
      builder.mutation<void, NotifyADSBInDangerParams>({
        query: ({ flightId, alert, location }) => ({
          url: '/notifyADSBInDanger',
          method: 'POST',
          params: { flightId, alert, location },
        }),
      }),
  }),
});

export const {
  useFindPositionsByDateTimeRangeMutation,
  useNotifyADSBInDangerMutation,
} = adsbApi;

export default adsbApi;
